import React from "react";
import classNames from "../../utilities/classNames";
import "./CurrencyPicker.types";
import styles from "./CurrencyPicker.module.css";
var CurrencySign = function (props) {
    var active = props.active, text = props.text, mobile = props.mobile;
    var startClassNames = classNames(styles.currency, mobile && styles["currency--mobile"], active && styles["currency--active"]);
    return React.createElement("div", { className: startClassNames }, text);
};
export default CurrencySign;
